import {useCallback} from "react";
import {YANDEX_METRIKA_COUNTER_ID} from "../Config";
import {pushEvent} from "./frontStatsQueue";

declare global {
    function ym(counterId: number, action: string, url?: string, options?: object): void;
}

export default function useYandexMetrika() {
    const hit = useCallback((url: string, options?: object) => {
        pushEvent({type: 'hit', timestamp: Date.now(), url, params: options});
        if (typeof ym !== 'undefined') {
            console.log('[YM] hit', url, options ?? '');
            ym(YANDEX_METRIKA_COUNTER_ID, 'hit', url, options);
        } else {
            console.log('[YM] hit (counter not loaded)', url, options ?? '');
        }
    }, []);

    const reachGoal = useCallback((goal: string, params?: object) => {
        pushEvent({type: 'reachGoal', timestamp: Date.now(), goal, params});
        if (typeof ym !== 'undefined') {
            console.log('[YM] reachGoal', goal, params ?? '');
            ym(YANDEX_METRIKA_COUNTER_ID, 'reachGoal', goal, params);
        } else {
            console.log('[YM] reachGoal (counter not loaded)', goal, params ?? '');
        }
    }, []);

    return {hit, reachGoal};
}
